import { create } from 'zustand';

interface LangState {
    languages: string[];
    baseLang: string;
    setLanguages: (l: string[]) => void;
}

export const useLangState = create<LangState>((set) => ({
  languages: [],
  baseLang: 'pl',
  setLanguages: (l) => set({ languages: l }),
}));
